/**
 * The two decisions the onboarding-roles panel gets wrong if left implicit.
 *
 * Both concern slugs the agency has no role for. The shipped defaults name roles
 * that were made by hand in production, so a fresh agency resolves none of them,
 * and the backend refuses a save that mentions one. That makes "which of these
 * do not exist" load-bearing rather than cosmetic, and worth testing away from
 * the component.
 */

/** Configured slugs this agency has no role for, in configured order. */
export function unresolvedSlugs(
  slugs: readonly string[] | undefined,
  knownSlugs: ReadonlySet<string>
): string[] {
  return (slugs ?? []).filter(slug => !knownSlugs.has(slug));
}

/**
 * Whether the draft would change what is in force.
 *
 * Order is not meaningful -- the backend resolves a set -- so a reorder is not
 * an edit, and Save stays disabled rather than writing an override that says
 * exactly what the defaults already said.
 */
export function hasArchetypeRoleEdits(
  archetypes: readonly string[],
  effective: Record<string, string[]>,
  draft: Record<string, string[]>
): boolean {
  return archetypes.some(archetype => {
    const before = [...(effective[archetype] ?? [])].sort();
    const after = [...(draft[archetype] ?? [])].sort();
    return (
      before.length !== after.length || before.some((s, i) => s !== after[i])
    );
  });
}
